import { Link,  useNavigate } from "react-router-dom";
import { memo } from "react";
import { useContext } from "react";
import { GlobalContext } from "../Context/GlobalState";

function Navbar() {
  const navigate = useNavigate();
  const { setLogin, isLogin,userKredi } = useContext(GlobalContext);
  const handleLogOut = () => {
    if (!isLogin) {
      navigate("/");
    }
    if (window.localStorage.user) {
      window.localStorage.removeItem("user");
      window.localStorage.setItem("isAuth", false);
      setLogin(false);
      navigate("/");
    } else {
    }
  };
  return isLogin? (
    <nav className="navbar navbar-expand-lg bg-light shadow-sm">
  <div className="container-fluid">
    {/* Anasayfa Sekmesi */}
    <Link
      className="navbar-brand fw-bold text-primary"
      style={{
        fontSize: 40,
        backgroundColor: "#bbdefb", // Açık mavi arka plan
        padding: "5px 15px",
        borderRadius: "8px",
        textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
        transition: "all 0.3s ease",
      }}
      to={isLogin ? "/home" : "/login"}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#bbdefb")} // Hover rengi
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#e3f2fd")}
    >
      Anasayfa
    </Link>

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        {/* Bağış Yap */}
        <li className="nav-item">
          <Link
            className="nav-link btn btn-primary text-white rounded px-3 py-2 me-2"
                style={{
              backgroundColor:"#007bb5",
              fontSize: 20,
                  transition: "all 0.3s ease",
              
            }}
            to={isLogin ? "/bagis" : "/"}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#007bb5")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#0d6efd")}
          >
            Bağış Yap
          </Link>
        </li>
        {/* Münavebe Kaydet */}
        <li className="nav-item">
          <Link
            className="nav-link text-dark rounded fw-bold"
            style={{ fontSize: 18 }}
                to={isLogin ? "/munavebekayit" : "/"}
                 onMouseEnter={(e) => (e.target.style.backgroundColor = "#bbdefb")} // Hover rengi
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
          >
            Münavebe Kaydet
          </Link>
        </li>
        {/* Avukat Kaydet */}
        <li className="nav-item">
          <Link
            className="nav-link text-dark rounded fw-bold"
            style={{ fontSize: 18 }}
                to={isLogin ? "/avukatkayit" : "/"}
                 onMouseEnter={(e) => (e.target.style.backgroundColor = "#bbdefb")} // Hover rengi
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
          >
            Avukat Kaydet
          </Link>
        </li>
        {/* Bilirkişi Kaydet */}
        <li className="nav-item">
          <Link
            className="nav-link text-dark rounded fw-bold"
            style={{ fontSize: 18 }}
                to={isLogin ? "/bilirkisikayit" : "/"}
                 onMouseEnter={(e) => (e.target.style.backgroundColor = "#bbdefb")} // Hover rengi
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
          >
            Bilirkişi Kaydet
          </Link>
        </li>
        {/* Nasıl Kullanılır */}
        <li className="nav-item">
          <Link
            className="nav-link text-dark rounded fw-bold"
            style={{ fontSize: 18 }}
                to={isLogin ? "/nasilkullanilir" : "/"}
                 onMouseEnter={(e) => (e.target.style.backgroundColor = "#bbdefb")} // Hover rengi
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
          >
            Nasıl Kullanılır
          </Link>
        </li>
      </ul>
      <form className="d-flex align-items-center">
        {isLogin && (
          <div className="text-dark me-4">
            <p className="mb-0 fw-bold">{window.localStorage.user}</p>
            <p className="mb-0" style={{ color: "red" }}>
              Kredi: {userKredi}
            </p>
          </div>
        )}
        <button
          className={`btn ${isLogin ? "btn-outline-danger" : "btn-outline-success"} btn-lg`}
          onClick={handleLogOut}
        >
          {isLogin ? "Çıkış Yap" : "Giriş Yap"}
        </button>
      </form>
    </div>
  </div>
</nav>


  ):"";
}
export default memo(Navbar);
